<div class="max-width-p">
  <benefit-header-summary
    headerText="{{ fixedBenefit.name }}"
    [showBudgetCard]="false"
  >
  </benefit-header-summary>
</div>
<div class="max-width" *ngIf="fixedBenefit">
  <div class="card">
    <div class="header-container">
      <div class="image">
        <img src="{{ fixedBenefit.pictureUrl }}" alt="{{ fixedBenefit.name}}" width="100" />
      </div>
    </div>
    <div class="second-desc">
      <p [innerHtml]="fixedBenefit?.description | accessibleImg"></p>
    </div>
    <div *ngIf="documents">
    <div class="bold dark-green">
      {{ 'FLEXIBLE_FIXED_BENEFITS.REQUIRED_DOCUMENTS' | translate }}
    </div>
    <div class="border-container">
      <a
        *ngFor="let fixedBenefitDocument of documents"
        href="javascript:void(0)"
        (click)="showDocument(fixedBenefitDocument)"
        class="document-card"
      >
        <span [ngClass]="'icon-file-text'" class="ficon feather"></span>
        <div class="text-card">{{ fixedBenefitDocument.displayName }}</div>
      </a>
    </div>
  </div>
  </div>

  <div class="card discounts-container" *ngIf="fixedBenefit?.discounts">
    <div class="bold dark-green discount-title" >
      Promoții
    </div>
    <!-- TO BE REPLACED with the actual search bar-->
    <div style="height: 35px; margin-bottom: 10px;">
      <input type="text" class="vertiva-align search-discounts" placeholder="Cauta promoții" (keyup)="searchDiscounts($event)"/>
    </div>
    <!-- -- -->
    <div class="discounts-card-container">
      <div class="discount-card" *ngFor="let discount of fixedBenefit?.discounts" (click)="showDiscount(discount)">
        <div class="discount-card-header-image" style="width: 50px;">
          <img src="{{ discount.store_logo }}" alt=""/>
        </div>
        <div class="vertical-align discount-store">
          <div>
            {{ discount?.store_name }}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="card expense-report-container" *ngIf="isExpenseReportBenefit && !expenseReportSent">
    <div class="bold" >
      {{ 'FLEXIBLE_FIXED_BENEFITS.EXPENSE_REPORT.TITLE' | translate }}
    </div>
    <p>
      {{ 'FLEXIBLE_FIXED_BENEFITS.EXPENSE_REPORT.DESCRIPTION' | translate }}    </p>
    <form class="form form-horizontal padding-24" [formGroup]="ExpenseReportForm">
      <div class="row">
        <div class="col-12">
          <div class="form-group row">
            <div class="col-sm-9 col-form-label">
              <label for="fullName">{{ 'FLEXIBLE_FIXED_BENEFITS.EXPENSE_REPORT.NAME' | translate }} </label>
            </div>
            <div class="col-sm-7">
              <div class="input-group input-group-merge">
                <input
                  type="text"
                  id="fullName"
                  class="form-control"
                  name="fullName"
                  value="test"
                  formControlName="fullName"
                  disabled
                />
              </div>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="form-group row">
            <div class="col-sm-9 col-form-label">
              <label for="email">{{ 'FLEXIBLE_FIXED_BENEFITS.EXPENSE_REPORT.EMAIL' | translate }}</label>
            </div>
            <div class="col-sm-7">
              <div class="input-group input-group-merge">
                <input
                  type="text"
                  id="email"
                  class="form-control"
                  name="email"
                  value="test@email.com"
                  formControlName="email"
                  disabled
                />
              </div>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="input-group separator"></div>
        </div>
        <div class="col-12">
          <div class="form-group row">
            <div class="col-sm-9 col-form-label">
              <label for="ExpenseReportAmount">{{ 'FLEXIBLE_FIXED_BENEFITS.EXPENSE_REPORT.AMOUNT' | translate }}</label>
              <label>{{ 'FLEXIBLE_FIXED_BENEFITS.EXPENSE_REPORT.AMOUNT_DESCRIPTION' | translate }}</label>
            </div>
            <div class="col-sm-7">
              <div class="input-group input-group-merge">
                <input
                  onwheel="return false;"
                  type="number"
                  id="ExpenseReportAmount"
                  class="form-control"
                  name="ExpenseReportAmount"
                  formControlName="ExpenseReportAmount"
                />
                <div class="input-group-append">
                  <span
                    class="input-group-text"
                    >RON</span>
                </div>
              </div>
              <div
              *ngIf="
                f.ExpenseReportAmount.errors &&
                addExpenseReportFormSubmitted
              "
              class="invalid-feedback"
              [ngClass]="{
                'd-block':
                  f.ExpenseReportAmount.errors &&
                  addExpenseReportFormSubmitted
              }"
            >
              <div *ngIf="f.ExpenseReportAmount.errors.required">
                <img src="../../../../../assets/images/icons/alert-triangle.svg" alt=""> {{ 'FLEXIBLE_FIXED_BENEFITS.EXPENSE_REPORT.REQUIRED_VALIDATION' | translate }}
              </div>
              <div *ngIf="f.ExpenseReportAmount.errors.pattern">
                <img src="../../../../../assets/images/icons/alert-triangle.svg" alt=""> {{ 'FLEXIBLE_FIXED_BENEFITS.EXPENSE_REPORT.AMOUNT_INVALID' | translate }}
              </div>
              <div *ngIf="f.ExpenseReportAmount.errors.limitExceeded">
                <img src="../../../../../assets/images/icons/alert-triangle.svg" alt=""> {{ f.ExpenseReportAmount.errors.limitExceeded.message }}
              </div>
            </div>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="form-group row">
            <div class="col-sm-9 col-form-label">
              <label for="ExpenseReportDescription">{{ 'FLEXIBLE_FIXED_BENEFITS.EXPENSE_REPORT.EXPENSE_DESCRIPTION' | translate }}</label>
            </div>
            <div class="col-sm-12">
              <div
                class="input-group input-group-merge textarea"
              >
                 <quill-editor
                  [modules]="modulesEditor"
                  theme="snow"
                  id="ExpenseReportDescription"
                  class="content-editor"
                  placeholder=""
                  (onEditorCreated)="onEditorCreated(this)"
                  formControlName="ExpenseReportDescription"
                  [styles]="{'height': '200px', 'border-color': '#D8D6DE',
                    'border-bottom-left-radius': '5px',
                    'border-bottom-right-radius': '5px'}">
                </quill-editor>

              </div>
              <div
              *ngIf="
                f.ExpenseReportDescription.errors &&
                addExpenseReportFormSubmitted
              "
              class="invalid-feedback"
              [ngClass]="{
                'd-block':
                  f.ExpenseReportDescription.errors &&
                  addExpenseReportFormSubmitted
              }"
            >
              <div *ngIf="f.ExpenseReportDescription.errors.required">
                <img src="../../../../../assets/images/icons/alert-triangle.svg" alt=""> {{ 'FLEXIBLE_FIXED_BENEFITS.EXPENSE_REPORT.REQUIRED_VALIDATION' | translate }}
              </div>
            </div>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="form-group row">
            <div class="col-sm-9 col-form-label">
              <label for="ExpenseReportDocuments">{{ 'FLEXIBLE_FIXED_BENEFITS.EXPENSE_REPORT.FILES' | translate }}</label>
            </div>
            <div class="col-sm-12">
              <div class="container">
                <input
                  type="file"
                  id="ExpenseReportDocuments"
                  name="ExpenseReportDocuments"
                  formControlName="ExpenseReportDocuments"
                  accept="image/png, image/jpeg, image/jpg, application/pdf"
                  multiple
                  (change)="selectFiles($event)" />
                <img src="../../../../../assets/images/icons/upload.svg" alt="">
                <div class="text-container">
                  <p>{{ 'FLEXIBLE_FIXED_BENEFITS.EXPENSE_REPORT.FILES_DESCRIPTION' | translate }}</p>
                  <div>
                    <div class="small-text">{{ 'FLEXIBLE_FIXED_BENEFITS.EXPENSE_REPORT.FILES_RESTRICTIONS' | translate }}</div>
                    <div>.pdf, .png, .jpeg </div>
                  </div>
                </div>
              </div>
              <div *ngIf="selectedFiles && selectedFiles.length > 0" class="files-list">
                <div class="single-file" *ngFor="let file of selectedFiles; let i = index">
                  <img src="../../../../../assets/images/icons/document.svg" class="document" alt="file">
                  <div class="info">
                    <h4 class="name">
                      {{ file?.name }}
                    </h4>
                    <div class="size">
                      {{ formatBytes(file?.size) }}
                    </div>
                    <app-progress [progress]="file?.progress"></app-progress>
                  </div>
                  <div>
                    <img src="../../../../../assets/images/icons/cancel.svg" class="delete" alt="file" (click)="deleteFile(i)">
                  </div>
                </div>
              </div>
              <div
                *ngIf="
                  f.ExpenseReportDocuments.errors &&
                  (addExpenseReportFormSubmitted || f.ExpenseReportDocuments.touched)
                "
                class="invalid-feedback"
                [ngClass]="{
                  'd-block':
                    f.ExpenseReportDocuments.errors &&
                    (addExpenseReportFormSubmitted || f.ExpenseReportDocuments.touched)
                }"
              >
                <div *ngIf="f.ExpenseReportDocuments.errors.invalidFileType">
                  <img src="../../../../../assets/images/icons/alert-triangle.svg"> {{ 'FLEXIBLE_FIXED_BENEFITS.EXPENSE_REPORT.FILE_TYPES_VALIDATION' | translate }}
                </div>
                <div *ngIf="f.ExpenseReportDocuments.errors.required">
                  <img src="../../../../../assets/images/icons/alert-triangle.svg"> {{ 'FLEXIBLE_FIXED_BENEFITS.EXPENSE_REPORT.REQUIRED_VALIDATION' | translate }}
                </div>
                <div *ngIf="f.ExpenseReportDocuments.errors.tooManyFiles">
                  <img src="../../../../../assets/images/icons/alert-triangle.svg"> {{ 'FLEXIBLE_FIXED_BENEFITS.EXPENSE_REPORT.FILE_NUMBER_VALIDATION' | translate }}
                </div>
                <div *ngIf="f.ExpenseReportDocuments.errors.fileSizeExceeded">
                  <img src="../../../../../assets/images/icons/alert-triangle.svg">
                  {{ f.ExpenseReportDocuments.errors.fileSizeExceeded.message | translate:f.ExpenseReportDocuments.errors.fileSizeExceeded.params }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12" *ngIf="policyCheckboxes.length > 0">
          <div class="benefit-wrapper mb-1">
            <div class="bold mb-1">{{ 'BENEFIT_SUMMARY.CHECKOUT_POLICY.CONSENTS' | translate }}</div>
            <app-required-consents
              [checkboxes]="policyCheckboxes"
              (consentChange)="onRequiredConsentChange()"
            ></app-required-consents>
          </div>
        </div>
        <div class="col-12 button-container">
          <app-error-messages
            [errorMessages]="errorMessages"
            [extraClass]="'text-center'"
          ></app-error-messages>
          <button class="send-expenseReport-button btn btn-primary mr-1" type="submit"
            [disabled]="!(requiredConsentsRef?.isComplete() ?? true)"
            (click)="addExpenseReport()">
             {{ 'FLEXIBLE_FIXED_BENEFITS.EXPENSE_REPORT.SEND_BUTTON' | translate }}
          </button>
          <div>
            {{ 'FLEXIBLE_FIXED_BENEFITS.EXPENSE_REPORT.SEND_BUTTON_DESCRIPTION' | translate }}
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="card expense-report-sent" *ngIf="expenseReportSent">
    <div class="text-card expense-report-success">
      <div><img src="../../../../../assets/images/icons/check-circle.svg"  alt="" role="presentation"></div>
      <div class="expense-report-sent-title vertical-align">{{ 'FLEXIBLE_FIXED_BENEFITS.EXPENSE_REPORT.EXPENSE_REPORT_SENT' | translate }}</div>
    </div>
    <div class="text-card">
      {{ 'FLEXIBLE_FIXED_BENEFITS.EXPENSE_REPORT.EXPENSE_REPORT_SENT_DESCRIPTION_2' | translate }}
    </div>
  </div>
</div>
